import type { CSSObject } from '@emotion/react';

/**
 * 스크린 리더 전용 요소 스타일입니다.
 */
export const visuallyHidden: CSSObject = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: '1px',
};
